import { format, isValid, parse } from "date-fns";

export const PAGE_SIZE = 6;

export const money = (value) => Number(value || 0).toLocaleString("en-PK");

export const parseDate = (value, dateOnly = false) => {
  if (!value) return null;
  const parsed = parse(value, dateOnly ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm:ss", new Date());
  if (isValid(parsed)) return parsed;
  const fallback = new Date(value);
  return isValid(fallback) ? fallback : null;
};

export const displayDate = (value, pattern, dateOnly = false) => {
  const date = parseDate(value, dateOnly);
  return date ? format(date, pattern) : "—";
};

export const orderGroup = (order) => {
  if (order.order_status === "cancelled" || order.cancelled) return "cancelled";
  if (order.order_status === "delivered" || order.delivered) return "completed";
  return "in_progress";
};

export const statusText = (order) => ({
  pending: "Booked",
  schedule: "Scheduled",
  confirmed: "Confirmed",
  out_for_pickup: "Out for Pickup",
  picked_up: "Picked Up",
  arrived: "In Laundry",
  processing: "In Progress",
  ready_for_delivery: "Ready for Delivery",
  out_for_delivery: "Out for Delivery",
  delivered: "Completed",
  cancelled: "Cancelled",
  failed: "Failed",
}[order.order_status] || "In Progress");

export const paymentText = (method) => ({
  cash_on_delivery: "COD",
  card_on_delivery: "Card",
  wallet_on_delivery: "Wallet",
  up_front_cash_payment: "Cash",
}[method] || "Digital");

export const serviceType = (order) => {
  if (Number(order?.laundry_delivery_type?.id) === 3) return "collect";
  if (Number(order.booking_type) === 2) return "express";
  return "regular";
};

export const progressStep = (order) => {
  if (order.delivered || order.order_status === "delivered") return 5;
  if (order.out_for_delivery || order.order_status === "out_for_delivery") return 4;
  if (["picked_up", "arrived", "processing", "ready_for_delivery"].includes(order.order_status) || order.processing || order.picked_up) return 3;
  if (["confirmed", "out_for_pickup", "schedule"].includes(order.order_status) || order.confirmed) return 2;
  return 1;
};

export const applyLocalFilters = (orders, filters, tab, search) => {
  const now = new Date();
  const oldest = filters.days === "all" ? null : new Date(now.getTime() - Number(filters.days) * 86400000);
  return orders.filter((order) => {
    if (tab !== "all" && orderGroup(order) !== tab) return false;
    if (search && !String(order.id).toLowerCase().includes(search.toLowerCase().trim())) return false;
    const created = parseDate(order.creation_date) || parseDate(order.pickup_date, true);
    if (oldest && created && created < oldest) return false;
    if (filters.statuses.length && !filters.statuses.includes(orderGroup(order))) return false;
    if (filters.services.length && !filters.services.includes(serviceType(order))) return false;
    if (filters.payments.length && !filters.payments.includes(paymentText(order.payment_method).toLowerCase())) return false;
    return true;
  });
};
